// extracted by mini-css-extract-plugin
module.exports =  {"numbers":"AboutSectionNumbers-module_numbers_f5db6","numbersButton":"AboutSectionNumbers-module_numbersButton_cf5f9"};